import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import {
  recallWorkspaceReturn,
  rememberWorkspaceReturn,
  workspaceReturnFromState,
  type WorkspaceReturn,
} from "@/lib/navigation/workspaceReturn";

/**
 * Where the workspace's back button leads: the page that opened the workspace, handed
 * over in the router state and kept while the reader stays inside the workspace (see
 * `lib/navigation/workspaceReturn`). Undefined when the workspace was opened plainly.
 */
export const useWorkspaceReturn = (
  workspaceId: string | undefined
): WorkspaceReturn | undefined => {
  const location = useLocation();
  const handedOver = workspaceReturnFromState(location.state);
  const returnTo = handedOver?.returnTo;
  const label = handedOver?.label;

  useEffect(() => {
    if (!workspaceId || !returnTo || !label) return;
    rememberWorkspaceReturn(workspaceId, { returnTo, label });
  }, [workspaceId, returnTo, label]);

  if (handedOver) return handedOver;
  return workspaceId ? recallWorkspaceReturn(workspaceId) : undefined;
};
